//original js
//検索ページでそれぞれのブログジャンル出し分け処理


document.addEventListener('DOMContentLoaded', function () {
  var dropdown = document.getElementById('genre-dropdown');
  var searchResultsSelector = '.grid__item-article'; // 検索結果のセレクタ

  // URL が除外すべき文字列を含んでいるかどうかを確認する関数
  function shouldExclude(url, excludedStrings) {
    return excludedStrings.some(function (excludedString) {
      return url.includes(excludedString);
    });
  }

  // 検索結果のフィルタリング処理
  function filterResults(selectedGenre) {
    var excludedStrings;
    var dynamicClass;

    // 条件分岐
    if (selectedGenre === 'all') {
      excludedStrings = [' ']; // すべて表示
      dynamicClass = 'article-genre-all';
    } else if (selectedGenre === 'topics') {
      excludedStrings = ['column/', 'news/'];
      dynamicClass = 'article-genre-topics';
    } else if (selectedGenre === 'column') {
      excludedStrings = ['news/', 'topics/'];
      dynamicClass = 'article-genre-column';
    } else if (selectedGenre === 'news') {
      excludedStrings = ['column/', 'topics/'];
      dynamicClass = 'article-genre-news';
    }

    // 検索結果を取得
    var searchResults = document.querySelectorAll(searchResultsSelector);

    // 各検索結果をループして除外・クラス付与する
    searchResults.forEach(function (result) {
      var resultUrlElement = result.querySelector('a.full-unstyled-link');
      if (resultUrlElement) {
        var resultUrl = resultUrlElement.getAttribute('href');

        // 除外対象なら非表示、そうでなければ再表示
        if (shouldExclude(resultUrl, excludedStrings)) {
          result.style.display = 'none';
        } else {
          result.style.display = '';
        }

        // 動的クラスを付与
        result.classList.remove('article-genre-all', 'article-genre-topics', 'article-genre-column', 'article-genre-news'); // 既存のクラスを削除
        result.classList.add(dynamicClass); // 選択されたジャンルのクラスを追加
      }
    });
  }

  // ドロップダウン変更時の処理
  dropdown.addEventListener('change', function () {
    var selectedGenre = dropdown.value;

    // 選択をローカルストレージに保存
    localStorage.setItem('selectedGenre', selectedGenre);

    // フィルタリング適用
    filterResults(selectedGenre);
  });

  // ページロード時の処理
  var savedGenre = localStorage.getItem('selectedGenre') || 'all'; // デフォルト値は 'all'
  dropdown.value = savedGenre; // ドロップダウンの値を復元
  filterResults(savedGenre);

  // ページネーション後の再適用（動的に要素が追加された場合）
  var observer = new MutationObserver(function () {
    filterResults(dropdown.value);
  });

  // 検索結果コンテナを監視（適宜変更）
  var searchContainer = document.querySelector('.template-search__results');
  if (searchContainer) {
    observer.observe(searchContainer, { childList: true, subtree: true });
  }
});
